<div *ngIf="currentActions && currentActions.length > 0">
  <div [ngClass]="closedType ? 'fw f-16' : 'fw'">Status: </div>
  <ng-container *ngFor="let critem of currentActions">
    <div class="text-blue" *ngIf="closedType && closedType === critem.closedType" (click)="openCurrentAction(critem)">
      {{critem.jurisdiction}} | {{critem.regulationStatus}}|
      {{critem.userName}} </div>
    <div class="text-blue" *ngIf="!closedType" (click)="openCurrentAction(critem)">{{critem.jurisdiction}} |
      {{critem.regulationStatus}} |
      {{critem.userName}} </div>
  </ng-container>
</div>

<!-- For Template 5 -->
<!-- <div *ngIf="currentActionsT5 && currentActionsT5.length > 0 && templateNo==5">
  <div [ngClass]="closedType ? 'fw f-16' : 'fw'">Status: </div>
  <ng-container *ngFor="let critem of currentActionsT5">
    <div class="text-blue" *ngIf="closedType && closedType === critem.closedType" (click)="openCurrentAction(critem)">
      {{critem.jurisdiction}} | {{critem.regulationStatus}} |
      {{critem.userName}}</div>
    <div class="text-blue" *ngIf="!closedType" (click)="openCurrentAction(critem)">{{critem.jurisdiction}} |
      {{critem.regulationStatus}} |
      {{critem.userName}}</div>
  </ng-container>
</div> -->

<!--For Template 4-->
<!-- <div *ngIf="currentActionsT4 && currentActionsT4.length > 0">
  <div [ngClass]="closedType ? 'fw f-16' : 'fw'">Statusssss: </div>
  <ng-container *ngFor="let critem of currentActionsT4">
    <div class="text-blue" *ngIf="closedType && closedType === critem.closedType">
      {{critem.jurisdiction}} | {{critem.regulationStatus}} |
      {{critem.userName}}</div>
    <div class="text-blue" *ngIf="!closedType">{{critem.jurisdiction}} |
      {{critem.regulationStatus}} |
      {{critem.userName}}</div>
  </ng-container>
</div> -->
